module.exports = __webpack_public_path__ + "media/88.f313e2d9.mp3";